import React, { useState } from 'react';
import './EmailForm.css'; // Import CSS file

const EmailForm = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setMessage('Email is required!');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch('https://www.radhaenterprises.co.in/submit_email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const result = await response.json();

      if (result.status === 'success') {
        setMessage('✅ Email saved successfully!');
        setEmail('');
      } else {
        setMessage(`❌ Error: ${result.message}`);
      }
    } catch (error) {
      setMessage('❌ Error submitting email!');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-container">
      
      {message && <p className="message">{message}</p>}
      <h2>Subscribe to my Newsletter</h2>
      <form onSubmit={handleSubmit} className="email-form">
        <input
          type="email"
          placeholder="Enter your email..."
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </form>
      
    </div>
  );
};

export default EmailForm;
